import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    lockOnConnect: {
      type: Boolean,
      default: false,
    }
  }

  async connect() {
    if (this.lockOnConnectValue) await this.#lock();
  }

  disconnect() {
    if (this.wakeLock !== undefined) {
      this.wakeLock.release().then(() => {
        this.wakeLock = null;
      });
    }
  }

  async lock() {
    if (!this.lockOnConnectValue) await this.#lock();
  }

  async #lock() {
    if ("wakeLock" in navigator) {
      try {
        this.wakeLock = await navigator.wakeLock.request("screen");
      } catch (err) {
        console.log("wake lock unsupported");
        console.log(err);
      }
    } else {
      console.log("wake lock unsupported");
    }
  }
}
